import {
  STATUSES,
  CLEAR_DATA,
  CREATE_CASTING,
  CREATE_CONTENT,
  CREATE_PROJECT,
  CREATE_ENCODING,
  CREATE_KEYWORD,
  CREATE_COPYRIGHT,
  DELETE_SOURCE_MEDIA,
  DELETE_STREAM,
  GET_COMPONENTS,
  GET_CONTENTS,
  GET_CONTENT,
  GET_DEPLOYMENT_STATUSES,
  GET_GIFTS,
  GET_HOSTED_STREAMS,
  GET_LANGUAGES,
  GET_COUNTRIES,
  GET_CASTINGS,
  GET_CASTING,
  GET_METADATAS,
  GET_OFFERS,
  GET_OFFER,
  GET_CAMPAIGN,
  GET_PROJECTS,
  GET_SMARTLISTS,
  GET_EDU_USER,
  GET_FILTERED_USERS,
  GET_USER,
  GET_USERS,
  GET_SOURCE_MEDIAS,
  SET_PAGE,
  SET_SEARCH_TEXT,
  SET_SORT,
  SET_FILTERS,
  RESET_ALL_FILTERS,
  UPDATE_CONTENT,
  UPDATE_PROJECT,
  GET_ORGA_CONFIG,
  GET_OFFER_STATS,
  GET_SUM_MEDIA_VIEWS,
  GET_USER_SUBSCRIPTIONS,
  GET_USER_PURCHASES,
  GET_OFFER_PLANS,
  GET_OFFER_USERS,
  GET_OFFER_USERS_FREECOPY,
  GET_UNSUBSCRIBER_TRANSACTIONS,
  GET_EDUS,
  GET_PLANS,
  GET_PLANS_OPTIONS,
  CANCEL_USER_SUBSCRIPTION,
  GET_INDEX_MEDIAS,
} from "actions/ActionTypes";

const itemInitialState = (sortColumn = "updated_at") => ({
  data: [],
  indexes: {},
  isFetching: false,
  isFetched: false,
  failed: false,
  page: {
    perPage: 10,
    total: 1,
    current: 1,
  },
  sort: {
    column: sortColumn,
    direction: "down",
  },
  filters: {},
  searchText: "",
});

const initialSort = {
  column: "updated_at",
  direction: "down",
};

const initialState = {
  user: itemInitialState(),
  castings: itemInitialState(),
  components: itemInitialState(),
  contents: itemInitialState(),
  index_medias: itemInitialState(),
  freecontents: itemInitialState(),
  deployments: itemInitialState(),
  free_copies: itemInitialState(),
  freecopies_batch: itemInitialState("updatedAt"),
  gifts: itemInitialState(),
  offers: itemInitialState(),
  bulks: itemInitialState("inserted_at"),
  projects: itemInitialState(),
  project: itemInitialState(),
  smartlists: itemInitialState(),
  smartlist: itemInitialState(),
  metadatas: itemInitialState(),
  source_medias: itemInitialState(),
  languages: itemInitialState(),
  countries: itemInitialState(),
  hosted_streams: itemInitialState(),
  orga_config: itemInitialState(),
  offer_stats: itemInitialState(),
  edus: itemInitialState(),
  offer_plans: itemInitialState(),
  filtered_users: itemInitialState(),
  users: itemInitialState("inserted_at"),
  live_media_views: itemInitialState(),
  sum_media_views: itemInitialState(),
  media_kpi: itemInitialState(),
  user_subscriptions: itemInitialState("subscription_date"),
  user_purchases: itemInitialState("purchase_date"),
  offer_users: itemInitialState(),
  offer_users_freecopy: itemInitialState(),
  ongoing_lives: itemInitialState(),
  unsubscriber_transactions: itemInitialState("unsubscription_date"),
  bw_dashboard: itemInitialState(),
  plans: itemInitialState(),
  plan_options: itemInitialState(),
  trailers: {
    data: [],
    isFetching: false,
    isFetched: false,
    failed: false,
  },
};

export default (state = initialState, action) => {
  switch (action.status) {
    case STATUSES.STARTED:
      return {
        ...state,
        [action.item]: {
          ...state[action.item],
          isFetching: true,
        },
      };
    case STATUSES.SUCCESSFUL:
      switch (action.type) {
        case CREATE_ENCODING:
        case GET_CASTINGS:
        case GET_PROJECTS:
        case GET_SMARTLISTS:
        case GET_CONTENTS:
        case GET_LANGUAGES:
        case GET_COUNTRIES:
        case GET_COMPONENTS:
        case GET_GIFTS:
        case GET_OFFERS:
        case GET_SOURCE_MEDIAS:
        case GET_HOSTED_STREAMS:
        case DELETE_SOURCE_MEDIA:
        case DELETE_STREAM:
        case GET_FILTERED_USERS:
        case GET_EDUS:
        case GET_USERS:
        case GET_PLANS:
        case GET_PLANS_OPTIONS:
        case GET_SUM_MEDIA_VIEWS:
        case GET_OFFER_PLANS:
        case GET_OFFER_USERS:
        case GET_OFFER_USERS_FREECOPY:
        case GET_USER_SUBSCRIPTIONS:
        case GET_USER_PURCHASES:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              isFetching: false,
              isFetched: true,
              failed: false,
              data: action.params.data || [],
              indexes: action.params.indexes || {},
              page: {
                ...state[action.item].page,
                total: Math.ceil(
                  action.params.data.length / state[action.item].page.perPage,
                ),
              },
            },
          };
        case GET_INDEX_MEDIAS:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              isFetching: false,
              isFetched: true,
              failed: false,
              data: action.params.data || [],
              indexes: action.params.indexes || {},
              page: {
                ...state[action.item].page,
                current: action.params.page.number,
                total: action.params.page.total,
                total_items: action.params.page.total_items,
              },
            },
          };
        case GET_CASTING:
        case GET_OFFER:
        case GET_EDU_USER:
        case GET_CAMPAIGN: {
          const index =
            state[action.item]?.indexes?.uuid?.[action.params.uuid]?.[0];

          const { data } = state[action.item];
          const item = action.params;
          item.isFetched = true;

          data[index] = {
            ...data[index],
            ...item,
          };

          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              isFetching: false,
              isFetched: true,
              failed: false,
              data,
            },
          };
        }
        case GET_UNSUBSCRIBER_TRANSACTIONS:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              isFetching: false,
              isFetched: true,
              failed: false,
              data: action.params.data || [],
              translate_reasons: action.params.translate_reasons || [],
              indexes: action.params.indexes || {},
              page: {
                ...state[action.item].page,
                total: Math.ceil(
                  action.params.data.length / state[action.item].page.perPage,
                ),
              },
            },
          };
        case GET_CONTENT: {
          const item = action.params;
          item.isFetched = true;

          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              data: action.params,
              isFetching: false,
              isFetched: true,
              failed: false,
            },
          };
        }
        case CREATE_CASTING:
        case CREATE_PROJECT:
        case UPDATE_PROJECT:
        case CREATE_CONTENT:
        case UPDATE_CONTENT:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              isFetching: false,
              isFetched: true,
              failed: false,
            },
          };
        case CREATE_KEYWORD:
        case CREATE_COPYRIGHT:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              isFetching: false,
              isFetched: true,
              failed: false,
              // Better join data than overwrite
              data: { ...state[action.item].data, ...action.params } || [],
            },
          };
        case GET_METADATAS:
        case GET_ORGA_CONFIG:
        case GET_OFFER_STATS:
        case GET_USER:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              isFetching: false,
              isFetched: true,
              failed: false,
              data: action.params || [],
            },
          };
        case GET_DEPLOYMENT_STATUSES:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              isFetching: false,
              isFetched: true,
              failed: false,
              indexes: {
                uuids: action.params || {},
              },
            },
          };
        case CLEAR_DATA:
          return {
            ...state,
            [action.item]: itemInitialState(),
          };
        case CANCEL_USER_SUBSCRIPTION: {
          // Update subscription status after cancel subscription
          const actionParams = action.params;
          const itemState = state[action.item];
          if (actionParams && actionParams.status && itemState.data) {
            itemState.data = itemState.data.map((item) => {
              if (item.subscription_uuid === actionParams.sub_uuid) {
                item.status = actionParams.status;
                item.next_billing_date = actionParams.end_date;
              }
              return item;
            });
          }
          return {
            ...state,
            [action.item]: itemState,
          };
        }
        default:
          return state;
      }
    case STATUSES.FAILED: {
      return {
        ...state,
        [action.item]: {
          ...state[action.item],
          isFetching: false,
          isFetched: true,
          failed: true,
          error: action.params.error,
        },
      };
    }

    default:
      switch (action.type) {
        case SET_PAGE:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              page: {
                ...state[action.item].page,
                current: action.currentPage,
                perPage: action.perPage,
              },
            },
          };
        case SET_SEARCH_TEXT:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              searchText: action.searchText,
            },
          };
        case SET_SORT:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              sort: action.sort,
            },
          };
        case SET_FILTERS:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              filters: action.filters,
            },
          };
        case RESET_ALL_FILTERS:
          return {
            ...state,
            [action.item]: {
              ...state[action.item],
              current: action.currentPage,
              per_page: action.perPage,
              filters: { status: "not_archived", type: action.itemType },
              sort: initialSort,
              searchText: "",
            },
          };
        default:
          return state;
      }
  }
};
